export default {
  en: {
    title: 'Trust Centre',
    createShareLink: 'Create Trust Centre link',
    shareYourProfile: 'Share your Trust Centre',
    createSidePanel: {
      title: 'Create Trust Centre link',
      desc: 'Create a secure, shareable link to give external access to your Risk Ledger Trust Centre. Choose when your link expires and deactivate it at any time.',
      input: 'What is this Trust Centre link for?',
      expiry: 'How long would you like to share it for?',
      expiryOptions: {
        days: '{n} days',
        unlimited: 'Unlimited',
      },
      domains: {
        label: 'Which domains would you like to include?',
        selectAll: 'Select all',
      },
      products: {
        label: 'Which products would you like to include answers for?',
        selectAll: 'Select all',
      },
      placeholder: 'E.g. client X RFP, client Y deal (Optional)',
      create: 'Create link',
      autoConnectEnabled: 'Allow recipient to connect automatically?',
    },
    sendSidePanel: {
      linkTitle: 'Share by link',
      linkDesc:
        'The link below gives external access to your Risk Ledger Trust Centre. It will expire after {n} days, and can be deactivated at any time.',
      linkDescUnlimited:
        'The link below gives external access to your Risk Ledger Trust Centre. It can be deactivated at any time.',
      copyTip: 'Anyone with this link can view your Risk Ledger Trust Centre until {date}.',
      copyTipUnlimited: 'Anyone with this link can view your Risk Ledger Trust Centre.',
      sendTitle: 'Share by email',
      sendPreview: 'Preview',
      sendDesc:
        'Enter the email address of your contact. Please feel free to personalise the email message, and we will securely send the above link to them on your behalf.',
      emailPlaceholder: "john.smith{'@'}example.com",
      messagePlaceholder: 'Personalised message (optional)',
      send: 'Send',
      sent: 'Sent',
      sentTip: 'An email has been sent to {email} containing a link to your Trust Centre.',
    },
    deactivateModal: {
      title: 'Deactivate your share link',
      description: 'Are you sure you would like to deactivate this link?',
      descriptionName: 'Are you sure you would like to deactivate "{name}"?',
      deactivate: 'Deactivate',
      cancel: 'Cancel',
      error: 'There was an error deactivating your shared link. Please try again.',
    },
    updateModal: {
      title: 'Edit your share link',
      nameLabel: 'What is this share link for?',
      namePlaceholder: 'E.g. client X RFP, client deal (Optional)',
      save: 'Save',
      cancel: 'Cancel',
      error: 'There was an error updating your shared link. Please try again.',
    },
    updateSidePanel: {
      title: 'Edit link',
      input: 'What is this share link for?',
      placeholder: 'E.g. client X RFP, client Y deal (Optional)',
      save: 'Save changes',
      domains: {
        label: 'Which domains would you like to include?',
        selectAll: 'Select all',
      },
      products: {
        label: 'Which products would you like to include answers for?',
        selectAll: 'Select all',
      },
      autoConnectEnabled: 'Allow recipient to connect automatically?',
    },
    table: {
      name: 'Name',
      status: 'Status',
      sentTo: 'Shared with',
      createdBy: 'Created by',
      domains: 'Domains',
      link: 'Link',
      actions: 'Actions',
      products: 'Products',
    },
    expiresAt: 'Expires {date}',
    expired: 'Expired {date}',
    createdBy: 'Created by {name}',
    deletedUser: 'Deleted user',
    sharedWith: 'Shared with {email}',
    allDomains: 'All domains',
    all: 'All',
    none: 'None',
    xDomains: '{n} domain | {n} domains',
    deactivate: 'Deactivate',
    deactivated: 'Deactivated {date}',
    status: {
      active: 'Active',
      expired: 'Expired',
      deactivated: 'Deactivated',
    },
    unlimited: 'Unlimited',
    unlimitedTooltip: 'This link does not expire.',
    copyTooltip: 'Copy the share link URL to your clipboard.',
    filters: {
      all: 'All',
      active: 'Active',
      deactivated: 'Deactivated',
      expired: 'Expired',
      noRequests: 'No requests found matching the filters.',
    },
    banner: {
      proactivelyShare:
        'Proactively share your Trust Centre with clients to reduce questionnaire burden and impress prospects.',
      createShare:
        'Create a secure link to share your up-to-date Trust Centre with anyone at any time, no sign up required.',
      oldDeactivate:
        'You are in control, deactivate links at any time. Links will automatically expire after 30 days.',
      deactivate: 'You are in control, choose when links expire and deactivate links at any time.',
      signUp:
        'Prospects can sign up quickly and easily for free to connect, access evidence and ask questions.',
    },
    error: 'There was an error loading your Trust Centre links. Please try again.',
    placeholder: {
      title: 'Share your first Trust Centre link',
      desc: 'Create a secure, shareable link to give external access to your Risk Ledger Trust Centre. Reduce the burden of questionnaires, cut sales cycles and impress prospects.',
      or: 'Or,',
      findOutMore: 'find out more →',
      intercomMessage: 'I would like to learn more about sharing my Trust Centre.',
      assessmentIncompleteTitle: 'Share your Trust Centre after completing your assessment',
      assessmentIncompleteDesc:
        'Create a secure, shareable link to give external access to your completed Risk Ledger Trust Centre. Reduce the burden of questionnaires, cut sales cycles and impress prospects.',
      assessmentIncompleteButton: 'Complete your assessment',
    },
    edit: {
      editTooltip: 'Edit link',
      deactivateTooltip: 'Deactivate link',
    },
  },
};
